import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {
    changeCurrentPath,
    fetchEntryList,
    setEntryListState,
    resetEntryListState,
    clearPdfItemsEntry,
    deleteEntryList,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';
import FormGroup from "@material-ui/core/FormGroup";
import MainButtons from "../../common/components/main-buttons";
import AlertDialog from "../../common/components/dialog/alert-dialog";
import ErrorDialog from "../../common/components/dialog/error-dialog";
import ReloadModal from "../../common/components/dialog/reload-dialog";
import LogoutModal from "../../common/components/dialog/logout-dialog";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import {DatePicker} from "material-ui-pickers";
import moment from "moment";
import Divider from "@material-ui/core/Divider";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Button from "@material-ui/core/Button";
import Tables from "../../common/components/table/common-table";
import PdfViewer from "../../common/components/viewer/pdf-viewer";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const columns = [
    { name: 'NohinYoteiYMD', title: '納品日' ,width:150},
    { name: 'DenpyoNO', title: '伝票番号' ,width:200},
    { name: 'MakerName', title: 'メーカー名' ,width:300},
    { name: 'OtodokesakiName', title: '納品先名' ,width:400},
    { name: 'isFixEntry', title: ' ' ,width:100 ,sortingEnabled:false,filteringEnabled: false},
    { name: 'isDeleteEntry', title: ' ' ,width:100 ,sortingEnabled:false,filteringEnabled: false},
];

const styles = theme => ({
    halfDivider:{
        width:30
    },
    datePicker : {
        marginTop : -7,
        marginRight:30,
        paddingRight:30,
        borderRight:'rgba(0,0,0,0.1) solid 1px',
        width:'150px'
    },
    extractionFormGroup: {
        display: 'flex',
        alignItems: 'flex-start',
        margin: '0 0 5px 0',
    },
    extractionForm: {
        margin: '-7px 16px 0 0',
        width: 'calc(150px + 1em)',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontFamily:'Noto Sans JP'
    },
    expands : {
        boxShadow:'initial'
    },
});


class EntryList extends Component {
    constructor(props) {
        super(props);
        const {dateType,selectedDate,DenpyoNO,MakerName,OtodokesakiName,filters,sorts} = props.settings;
        this.state = {
            dateType,
            selectedDate,
            DenpyoNO,
            MakerName,
            OtodokesakiName,
            filters,
            sorts,

            selection:null,
            dialogOpen : false,
        };
        this.nextIsDetail = false;
    }
    UNSAFE_componentWillMount(){

        const {dispatch,settings} = this.props;
        if(settings.isAfterUpdate){
            dispatch(setEntryListState({
                isAfterUpdate:false
            }));
            this.handleClickSumup()
        }
    }

    componentDidMount() {
        const { dispatch, history } = this.props;
        window.scrollTo(0, 0);
        dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
    }
    componentWillUnmount(){
        const { dispatch} = this.props;

        if(this.nextIsDetail){
            const {dateType,selectedDate,DenpyoNO,MakerName,OtodokesakiName,filters,sorts} = this.state;
            dispatch(setEntryListState({
                dateType,
                selectedDate,
                DenpyoNO,
                MakerName,
                OtodokesakiName,
                filters,
                sorts,
            }))
        }
        else{
            dispatch(resetEntryListState());
        }
    }
    /** event handlers **/
    handleDateTypeChange = event => {
        this.setState({ dateType: event.target.value });
    };
    handleSelectedDateChange = selectedDate => {
        this.setState({
            selectedDate: selectedDate
        });
    };
    handleSelectedDateInputChange = event =>{
        if(!event.target.value) this.setState({ selectedDate: null });
    }

    handleClickDetail = event => {
        const {history} = this.props;
        this.nextIsDetail = true;
        history.push('/entry-detail/0');
    };

    handleClickDetailRow = row => {
        const {history} = this.props;
        const id = row.id;
        this.nextIsDetail = true;
        history.push('/entry-detail/'+id);
    };

    handleClickSumup = event => {
        const {dispatch} = this.props;
        const {dateType,selectedDate, DenpyoNO,MakerName,OtodokesakiName} = this.state;
        this.setState({
            selections:[]
        });
        dispatch(fetchEntryList({
            dateType,
            selectedDate : !(selectedDate) ? null : selectedDate.format('YYYY-MM-DD'),
            DenpyoNO : DenpyoNO || null,
            MakerName : MakerName || null,
            OtodokesakiName : OtodokesakiName || null,
            SessionID : this.props.auth.SessionID
        }));
    };

    handleChangeText = (event) =>{
        this.setState({
            [event.target.name]:event.target.value
        })
    }

    handleClickClear = () =>{
        const {dispatch} = this.props;
        dispatch(resetEntryListState());
        this.setState({
            dateType:'0',
            selectedDate:moment(),
            DenpyoNO: '',
            MakerName: '',
            OtodokesakiName: '',
            sorts:[{columnName:'DenpyoNO',direction:'asc'}],
            filters : [],
        });

    };

    afterCloseFunc = () => {
        const { dispatch} = this.props;
        dispatch(clearPdfItemsEntry());
    };

    handleClickDelete = (row) => {
        const selection = row["id"];
        this.setState({
            selection,
            dialogOpen : true
        });
    }
    cancelDelete = () =>{
        this.setState({
            dialogOpen:false
        });
    };

    doDelete = () =>{
        this.setState({
            dialogOpen:false
        });
        const {dispatch,auth} = this.props;
        const {selection,dateType,selectedDate,DenpyoNO,MakerName,OtodokesakiName} = this.state;
        dispatch(deleteEntryList({
            HeaderID : selection,
            dateType,
            selectedDate : !(selectedDate) ? null : selectedDate.format('YYYY-MM-DD'),
            DenpyoNO : DenpyoNO || null,
            MakerName : MakerName || null,
            OtodokesakiName : OtodokesakiName || null,
            SessionID : auth.SessionID
        }));
    };

    handleSortOrderChange = (sorts) =>{
        this.setState({sorts})
    }
    handleFilterChange = (filters) =>{
        this.setState({filters})
    }


    render() {
        const { classes, settings} = this.props;
        const {
            dateType,selectedDate,DenpyoNO,MakerName,OtodokesakiName,filters,sorts,
            dialogOpen
        } = this.state;

        const printDialogOpen = (settings.pdfPath !== undefined);

        const mainButtons = [
            {type:'NEXT',func:this.handleClickDetail,text:"新規登録"},
            {type:'CLEAR',func:this.handleClickClear,text:"クリア"}
        ];

        const clickableColumns = [
            {name:'isFixEntry',func:this.handleClickDetailRow,type:'button',text:'修正'},
            {name:'isDeleteEntry',func:this.handleClickDelete,type:'button',text:'削除',visibleKeyColumn:'isDeletable'}
        ];


        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>エントリー伝票検索・修正削除</h2>
                    </section>
                    <ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                            <Typography className={classes.heading}>抽出条件</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <FormGroup row className={classes.extractionFormGroup}>
                                <RadioGroup
                                    aria-label="gender"
                                    name="gender2"
                                    value={dateType}
                                    onChange={this.handleDateTypeChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio />}
                                        label="納品日"

                                    />
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio />}
                                        label="登録日"
                                    />
                                </RadioGroup>
                                <DatePicker
                                    keyboard
                                    label="検索日付"
                                    value={selectedDate}
                                    onChange={this.handleSelectedDateChange}
                                    onInputChange={this.handleSelectedDateInputChange}
                                    format="YYYY/MM/DD"
                                    className={classes.datePicker}
                                    invalidDateMessage="日付が正しくありません"
                                    cancelLabel={"キャンセル"}
                                />
                                <TextField
                                    label="伝票番号"
                                    className={classes.extractionForm}
                                    onChange={this.handleChangeText}
                                    name="DenpyoNO"
                                    inputProps={{
                                        placeholder: '',
                                    }}
                                    value={DenpyoNO}
                                />
                                <TextField
                                    label="メーカー名"
                                    className={classes.extractionForm}
                                    onChange={this.handleChangeText}
                                    name="MakerName"
                                    inputProps={{
                                        placeholder: '',
                                    }}
                                    value={MakerName}
                                />
                                <TextField
                                    label="納品先名"
                                    className={classes.extractionForm}
                                    onChange={this.handleChangeText}
                                    name="OtodokesakiName"
                                    inputProps={{
                                        placeholder: '',
                                    }}
                                    value={OtodokesakiName}
                                />

                            </FormGroup>
                        </ExpansionPanelDetails>
                        <Divider />
                        <ExpansionPanelActions>
                            <Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup}>
                                集計
                            </Button>
                        </ExpansionPanelActions>
                    </ExpansionPanel>
                    <section className="with_button">
                        <Tables
                            dataSource={settings.data}
                            columns={columns}
                            clickableColumns={clickableColumns}
                            hasSelections={false}
                            filters={filters}
                            getSortOrders={this.handleSortOrderChange}
                            getFilters={this.handleFilterChange}
                            defaultSorts={sorts}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                {printDialogOpen &&
                <PdfViewer
                    filePath={settings.pdfPath}
                    afterCloseFunc={this.afterCloseFunc}
                />
                }
                <AlertDialog
                    open={dialogOpen}
                    title={"確認"}
                    text={<span>対象データを削除します、よろしいですか？</span>}
                    okFunction={this.doDelete}
                    closeFunction={this.cancelUpdate}
                />
                <ErrorDialog
                    open={this.props.settings.isProcessError}
                />
                <ReloadModal />
                <LogoutModal />

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        navigation : state.navigation,
        auth: state.auth,
        settings : state.entryListSettings
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(EntryList);



// WEBPACK FOOTER //
// ./src/routes/entry-list/index.js